import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Active from './active/Active'
import DiscountForm from './discountForm/DiscountForm'
import Inactive from './inactive/Inactive'

const Discount = () => {
  return (
    <Row className=''>
      <Col>
        <DiscountForm />
      </Col>
      <Col>
        <Active />
      </Col>
      <Col>
        <Inactive />
      </Col>
    </Row>
  )
}

export default Discount